var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 66,
    viewBox: "0 0 96 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M77.4375 25.125C74.625 11.4375 62.625 0.9375 48 0.9375C36.375 0.9375 26.4375 7.5 21.375 17.25C9.375 18.375 0 28.6875 0 41.0625C0 54.1875 10.6875 65.0625 24 65.0625H75.9375C87 65.0625 96 56.0625 96 45C96 34.5 87.75 25.875 77.4375 25.125ZM75.9375 57H24C15.1875 57 8.0625 49.875 8.0625 41.0625C8.0625 32.8125 14.0625 25.875 22.3125 25.125L26.4375 24.75L28.5 20.8125C32.25 13.5 39.75 9 48 9C58.5 9 67.5 16.5 69.5625 26.8125L70.6875 32.8125L76.875 33.1875C83.0625 33.5625 87.9375 38.8125 87.9375 45C87.9375 51.5625 82.6875 57 75.9375 57ZM32.0625 36.9375H42.1875V48.9375H53.8125V36.9375H63.9375L48 21L32.0625 36.9375Z",
    fill: "#565660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapUpload);
export default __webpack_public_path__ + "static/media/drap-upload.7d34c7ae19201bb9c9020834d3890a0e.svg";
export { ForwardRef as ReactComponent };